export default build =>
  build.query({
    query: ({ linkId, whitelabelSlug }) => {
      return {
        url: `/links/${linkId}/whitelabel/${whitelabelSlug}`,
        method: 'GET',
      }
    },
  })
